var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60628 5.78898L9.617 12.0041C10.928 13.3564 13.0709 13.3575 14.383 12.0041L20.3937 5.78898C20.4542 5.72642 20.4454 5.62339 20.3752 5.57277C19.7621 5.13087 19.0162 4.8689 18.2127 4.8689H5.7873C4.98377 4.8689 4.23786 5.13092 3.62479 5.57277C3.55457 5.62339 3.54575 5.72642 3.60628 5.78898ZM2 8.7832C2 8.13017 2.15666 7.51315 2.4326 6.97083C2.47575 6.88599 2.58512 6.86883 2.6507 6.9366L8.58533 13.0703C10.4646 15.0155 13.5342 15.0166 15.4147 13.0703L21.3493 6.9366C21.4149 6.86883 21.5243 6.88599 21.5674 6.97083C21.8433 7.51315 22 8.13021 22 8.7832V16.9545C22 19.1145 20.3 20.8689 18.2127 20.8689H5.7873C3.70005 20.8689 2 19.1145 2 16.9545V8.7832Z",
    fill: "#2D9764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.894fb2e77df166d609f5e571d860b468.svg";
export { ForwardRef as ReactComponent };